import React, { useEffect ,useState} from 'react';
import { useDispatch, useSelector } from 'react-redux'
import {
    getSpaceData,
    deleteSpaceDetails,
    getSpaceActivities,
    fetchSpacesStatus,
    getSpaceFilterData, 
    updateStatus,
    checkSpaceInWeeklyPicks,
    deleteWeeklyPicks,
    clearSpaceWeeklyPicksCheck
} from '../SpaceAction';
import 'antd/dist/antd.css';
import { Table, Modal, Button, Input, Spin } from 'antd';
import {PlusOutlined,LeftOutlined,RightOutlined,SearchOutlined} from '@ant-design/icons';
import toastr from 'toastr';
import SelectOption from '../../../common/Select'
import {COUNTRY_CODES, POPUP_STATUS, SPACE_STATUS} from '../../../common/constants'
import {MS_URL} from "../../../../settings";
import { useCookies } from 'react-cookie';

const SpaceList = ({history}) => {

    const dispatch = useDispatch();
    const [selectedRow,setSelectedRow] = useState();
    const [isPopupModal,setIsPopupModal] = useState(false);
    const [page,setPage] = useState(1);
    const [email, setEmail] = useState(null);
    const spaceActivities = useSelector(state => state.space?.spaceActivities?.data || []);
    const spaceData = useSelector(state => state.space?.spaceData || []);
    const pageSize = 5;
    const spaceStatus = useSelector(state => state.space?.spaceStatus?.data || []);
    const spaceWeeklyPicksCheck = useSelector(state => state.space?.spaceWeeklyPicksCheck || {});
    const [status, setStatus] = useState(SPACE_STATUS.ACTIVE);
    const [country, setCountry] = useState(COUNTRY_CODES[0].name);
    const [popupStatus, setPopupStatus] = useState('');
    const [actionStatus, setActionStatus] = useState('');
    const [cookies, setCookie] = useCookies(['country']);

    useEffect(() => {
        dispatch(getSpaceData(page, pageSize, email, country, status));
    },[]);

    useEffect(() => { 
        dispatch(fetchSpacesStatus())
    },[])

    useEffect(() => {
        // Handle weekly picks check result - show single modal with all info
        if (spaceWeeklyPicksCheck.data && !spaceWeeklyPicksCheck.fetching) {
            // Show confirmation modal regardless of weekly picks status
            setIsPopupModal(true);
        }
    }, [spaceWeeklyPicksCheck]);

    const handlePageChange = (page) => {
        setPage(page)
        dispatch(getSpaceData(page, pageSize, email, country, status));
    }

    const handleSearchOnclick = (e) => {
        dispatch(getSpaceData(page, pageSize, email, country, status));
        setPage(1);
    }

    const handleModalDeActivate = (value) => {
        setSelectedRow(value);
        setPopupStatus(POPUP_STATUS.DEACTIVATE);
        setActionStatus(SPACE_STATUS.INACTIVE);
        
        // Check if space is used in weekly picks before showing modal
        dispatch(checkSpaceInWeeklyPicks(value.spaceId, country));
    };

    const handleModalActivate = (value) => {
        setSelectedRow(value);
        if(value.spaceStatus === SPACE_STATUS.PENDING){
            setPopupStatus(POPUP_STATUS.APPROVE);
        }else {
            setPopupStatus(POPUP_STATUS.ACTIVATE);
        }
        setActionStatus(SPACE_STATUS.ACTIVE);
        setIsPopupModal(true);
    };

    const handleModalReject = (value) => {
        setSelectedRow(value);
        setPopupStatus(POPUP_STATUS.REJECT);
        setActionStatus(SPACE_STATUS.DECLINED);
        setIsPopupModal(true);
    };

    const handleAction = () => {
        const value = {
            id:selectedRow.spaceId,
            status:actionStatus
        }
        
        // If deactivating a space that's in weekly picks, remove it from weekly picks first
        if (actionStatus === SPACE_STATUS.INACTIVE && spaceWeeklyPicksCheck.data?.isUsed) {
            dispatch(deleteWeeklyPicks(country, selectedRow.spaceId));
            toastr.info('Space has been removed from Weekly Picks.');
        }
        
        dispatch(updateStatus(value, selectedRow.version, page, pageSize, email, country, status));
        setIsPopupModal(false);
        dispatch(clearSpaceWeeklyPicksCheck());
    }
    const abortAction = () => {
        setIsPopupModal(false);
        dispatch(clearSpaceWeeklyPicksCheck());
    }

    const handlePagination = (type) => {
        if(type==='next' && page>=1){
            handlePageChange(page+1);
        }else if(type==='prev' && page>1){
            handlePageChange(page-1)
        }
    }
    const navigateUpdate = (record) => {
        window.location.href = `/dashboard/space/edit?spcId=${record.spaceId}&spcCategory=${record.category}`;
    }

    const columns = [
        {
            title: 'Space ID',
            dataIndex: 'spaceId',
            key: 'spaceId',
            render: (value,record) => <a onClick={() => {navigateUpdate(record)}}> {value}</a>
        },
        {
            title: 'Organization Name',
            dataIndex: 'organizationName',
            key: 'organizationName',
            width: 150,
        },
        {
            title: 'Category',
            dataIndex: 'category',
            key: 'category',
            filters: spaceActivities.map(category => {return{text: category.name, value: category.name}}),
            onFilter: (value, record) => record.category === value ,
        },
        {
            title: 'Activity',
            dataIndex: 'activity',
            key: 'activity.name',
            render: (activity,record) => <span>{activity.map((act, index) =>  <a onClick={() => {navigateToSpace(act.id, record.spaceId, record.chargingUnit)}}>{act.name}{index < activity.length -1 && `,`}</a>)}</span>
        },
        {
            title: 'Host Name',
            dataIndex: 'host',
            key: 'hostName',
            width: 150,
            render: (text) => {
                return text.name;
            }
        },
        {
            title: 'Host Email',
            dataIndex: 'host',
            key: 'hostEmail',
            render: (text) => {
                return text.email;
            }
        },
        {
            title: 'Space Name',
            dataIndex: 'spaceName',
            key: 'spaceName',
            width: 150,
        },
        {
            title: 'Date Listed',
            dataIndex: 'createdDate',
            key: 'dateListed',
        },
        {
            title: '',
            dataIndex: 'action',
            key: 'action',

            render: (value, row) =>{

                if(row.spaceStatus === SPACE_STATUS.ACTIVE){
                    return (
                        <Button onClick={() => {handleModalDeActivate(row)}}>Deactivate
                        </Button>
                    )
                }else if (row.spaceStatus === SPACE_STATUS.PENDING){
                    return (
                        <>
                            <Button  onClick={() => {handleModalActivate(row)}}>Approve
                            </Button>
                            <Button onClick={() => {handleModalReject(row)}}>Reject
                            </Button>
                        </>
                    )
                }else {
                    return (
                        <Button onClick={() => {handleModalActivate(row)}}>{row.spaceStatus === SPACE_STATUS.INACTIVE ? `Activate`:`Approve`}
                        </Button>
                    )
                }
    }
        },
    ];

    const handleCountryFilterOnclick = (country) => {
        setCountry(country);
        dispatch(getSpaceData(page, pageSize, email, country, status));
    };
    const selectedStatus = spaceStatus.map(status => (
        {name: status}
    ));
    const handleStatusFilterOnclick = (status) => {
        setStatus(status);
        dispatch(getSpaceData(page, pageSize, email, country, status));
    };

    const navigateToSpace = (eventId, spaceId, unit) => {
        const {label} = COUNTRY_CODES.find(value => value.name === country);
        window.open(`${MS_URL}/${label.replaceAll(" ", "-")}/space/bookings?eventTypeId=${eventId}&spaceId=${spaceId}&unit=${unit}`);
    };

    useEffect(()=>{
        if(country?.length>0)
        setCookie('country',country);
    },[country])

  return (
        <div>
            <section className="space-listing-section">
                <div className="container">
                    <p className="title">Spaces <Button className="btn-space" type="primary" onClick={() => {history.push(`/dashboard/space/add`)}} icon={<PlusOutlined/>} size={"medium"}>Add Space</Button> 
                        {'  '}<input className="search-input" placeholder={'Email or Space Name / ID'} onChange={(e) => setEmail(e.currentTarget.value)}></input> <Button className="btn-search" type="primary" onClick={handleSearchOnclick} icon={<SearchOutlined/>} size={"medium"}>Search</Button>
                    </p>
                    <div class="search-filter-row">
                        <div class="search-filter-col">
                            <SelectOption
                                isMultiple={false}
                                label={'Country'} 
                                name={'Country'}
                                placeholder={'Country'}
                                values={COUNTRY_CODES}
                                handleOnSelect={handleCountryFilterOnclick}
                                labelName={'label'} 
                                valueName={'name'}
                                defaultValue={COUNTRY_CODES[0].name}
                             />
                        </div>
                        <div class="search-filter-col">
                            <SelectOption
                                isMultiple={false}
                                label={'Space status'} 
                                name={'Space status'}
                                placeholder={'Space status'}
                                values={selectedStatus}
                                handleOnSelect={handleStatusFilterOnclick}
                                labelName={'name'}
                                valueName={'name'}
                                defaultValue={status}
                             />
                        </div>
                    </div>
                    {spaceData.fetching ?<><br/> <br/> <br/><div className="spin-space-list"><Spin size="large"></Spin></div> </>: <> <Table className="space-listing-table" dataSource={spaceData.data} columns={columns} pagination={false} scroll={{x:true, y:true}}/>
                    <p className="pagination-wrap"><Button type={"default"} size={"medium"} icon={<LeftOutlined />} onClick={() => {handlePagination('prev')}} disabled={page<=1}></Button>   {`${page}`}   
                    <Button type={"default"} size={"medium"} icon={<RightOutlined />} onClick={() => {handlePagination('next')}} disabled={spaceData?.length===0}></Button></p>
                    </>}
                </div>
                <Modal
                    visible={isPopupModal}
                    className="ms-styles-wrapper space-delete-modal"
                    footer={null}
                >
                    <div className="header">
                        <p className="title">{popupStatus} Space</p>
                        <span className="content">
                            Are you sure you want to {popupStatus.toLowerCase()} the {selectedRow?.spaceName}?
                            {spaceWeeklyPicksCheck.data?.isUsed && (
                                <div className="warning-box">
                                    <div className="warning-title">
                                        <span className="warning-icon">⚠️</span>
                                        Warning
                                    </div>
                                    <div className="warning-message">
                                        This space is currently being used in Weekly Picks. 
                                        Deactivating it will automatically remove it from the Weekly Picks list.
                                    </div>
                                </div>
                            )}
                        </span>
                    </div>
                    <div className="footer">
                        <button className="btn btn-no" onClick={abortAction}>Cancel</button>
                        <button 
                            className={`btn ${spaceWeeklyPicksCheck.data?.isUsed ? 'btn-warning' : 'btn-yes'}`} 
                            onClick={handleAction}
                        >
                            {spaceWeeklyPicksCheck.data?.isUsed ? 'Proceed' : 'Yes'}
                        </button>
                    </div>
                </Modal>
            </section>
        </div>
  );
};

export default SpaceList;
